<template>
  <div v-loading="show" class="pendingList-wrapper">
    <h2 class="page-title">{{ $t("memberGroup") }}</h2>
    <el-divider></el-divider>
    <el-button @click="dialogVisible = true" v-if="membership_edit === '1'">{{ $t("CreateList") }}</el-button>
    <!--<el-button @click="dialogVisible_zy = true">{{ $t("ChangeList") }}</el-button>
    <el-button  >
		 <a :href="'#/wlogin?whatsapp='+qyid+'&pageid='+qyid">{{ $t("importmyaddress") }}</a> 
	
	</el-button>-->
    <template v-if="membership_read === '1'">
        <el-table :data="tableData" stripe @sort-change="sortChange" style="width: 100%">
        <el-table-column prop="storeid" :label="$t('storeid')" sortable="custom" width="">
        </el-table-column>
        <el-table-column prop="title" :label="$t('groupName')" sortable="custom">
        </el-table-column>
        <!--  <el-table-column prop="filepath" :label="$t('templatePath')" width="380">
        </el-table-column> -->
        <el-table-column prop="totaldaifanum" :label="$t('memberNumber')" sortable="custom">
            <template slot-scope="scope">
            <div @click="getlist_daifaid(scope.row.id)">
                {{ scope.row.totaldaifanum }}
            </div>
            </template>

        </el-table-column>

        <el-table-column prop="operation" :label="$t('adminset')" align="center">
            <template slot-scope="scope">
            <div class="operationVid">
                <el-button @click="insertitem(scope.row.id)" v-if="membership_edit === '1'">{{ $t("addMember") }}</el-button>
                <el-button @click="edititem(scope.row.id, scope.row.title)" v-if="membership_edit === '1'">{{ $t("editGroup") }}</el-button>
                <el-button @click="delitem(scope.row.id)" v-if="membership_edit === '1'">{{ $t("deleteGroup") }}</el-button>
                <span v-if="membership_edit === '0'">{{ $t("NoPermissions") }}</span>
            </div>
            </template>
        </el-table-column>
        <!--      <el-table-column prop="operation" label="管理" align="center" width="180">
            <template slot-scope="scope">
            <div class="operationVid">
                <span
                class="operationBef"
                @click="senditem(scope.row)"
                
                >创建发送任务</span>
            

    
            </div>
            </template>
        </el-table-column> -->
        </el-table>
        <div class="pagination flex-center">
        <span class="el-pagination__total">{{ $t("total") }} {{ totalRecord }} {{ $t("items") }}</span>
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            layout="prev,pager,next" :total="totalRecord"></el-pagination>
        </div>
    </template>
    <template v-if="membership_read === '0'">
        <span>{{ $t("NoPermissions") }}</span>
    </template>

    <!-- add -->
    <el-dialog :title="$t('CreateList')" :visible.sync="dialogVisible" :width="$store.state.isMobile ? '90%' : '756px'"
      :before-close="handleClose">
      <!--
      <div class="add-template">
        <el-form ref="form" :model="form">

          <el-form-item :label="$t('ziyuanType')">
            <el-select v-model="type" placeholder="">
              <el-option :label="$t('typewhatsapp')" value="whatsapp"></el-option>
              <!--    <el-option :label="$t('typesms')" value="sms"></el-option>
			          <el-option :label="$t('typeEmail')" value="email"></el-option> -->
            <!--</el-select>
          </el-form-item>
          <el-form-item :label="$t('groupName')">



            <el-input v-model="title" type="textarea" :rows="2"></el-input>
          </el-form-item>

          <el-form-item :label="$t('uploadFiles') + ':'" prop="excel">
            <el-upload class="upload-demo" ref="upload" action :http-request="httpRequest" :before-upload="beforeUpload"
              :on-exceed="handleExceed" :limit="1" accept=".csv">
              <el-button slot="trigger" size="small" type="primary">{{ $t("selectFiles") }}</el-button>
              <div slot="tip" class="el-upload__tip">
                {{ $t("uploadTips") }}
              </div>
              <div slot="tip" class="el-upload__tip">
                <a href="temp.csv">{{ $t("downloadModules") }}</a>
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t("Cancel") }}</el-button>
        <el-button type="primary" @click="submitImportForm">{{
          $t("Sure")
        }}</el-button>
      </span>-->

      <el-form ref="form" :model="form">
        <el-image style="width: 702px; height: 529px" :src="require(`@/assets/images/meta2026.jpg`)"
					:fit="fit" />
        <el-button @click="dialogVisible = false">{{ $t("Sure") }}</el-button>
      </el-form>


    </el-dialog>

    <!-- edit -->
    <el-dialog :title="$t('editMemberGroup')" :visible.sync="dialogGroupVisible"
      :width="$store.state.isMobile ? '90%' : '556px'" :before-close="handleClose">
      <!--
      <h3>{{ dialogGroupVisibleTitle }}</h3>
      <br />
      <br />-->
      <div class="add-template">
        <el-form ref="form" :model="form">
            <template>
                <el-button @click="exporttocsv(dialogGroupVisibleTitle)">{{ $t("exportMemberGroup") }}</el-button>
            </template>
          <el-table :data="daifalistByGroup.slice((daifalistByGroupCurrentPage - 1) * daifalistByGroupPageSize, daifalistByGroupCurrentPage * daifalistByGroupPageSize)
            " stripe @sort-change="sortChange_group" style="width: 100%">



            <!--  <el-table-column prop="filepath" :label="$t('templatePath')" width="380">
      </el-table-column> -->
            <el-table-column prop="nickname" :label="$t('memberName')" sortable="custom">
            </el-table-column>

            <el-table-column prop="whatsapp" :label="$t('phoneNumber')" sortable="custom">
            </el-table-column>

            <el-table-column prop="operation" :label="$t('adminset')" align="center" width="180">
              <template slot-scope="scope">
                <div class="operationVid">
                  <el-button @click="deleteMemeber(scope.row.id)">{{ $t("removeMember") }}</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination flex-center">
            <span class="el-pagination__total">{{ $t("total") }} {{ daifalistByGroup.length }} {{ $t("items") }}</span>
            <el-pagination background @current-change="handleGroupCurrentChange"
              :current-page="daifalistByGroupCurrentPage" :page-size="daifalistByGroupPageSize" layout="prev,pager,next"
              :total="daifalistByGroup.length"></el-pagination>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogGroupVisible = false">{{ $t("Cancel") }}</el-button>
        <el-button type="primary" @click="dialogGroupVisible = false">{{
          $t("Sure")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- insert -->
    <el-dialog :title="$t('addMember')" :visible.sync="dialogInsertVisible"
      :width="$store.state.isMobile ? '90%' : '756px'" :before-close="handleClose">
      <el-form ref="form" :model="form">
        <el-image style="width: 702px; height: 529px" :src="require(`@/assets/images/meta2026.jpg`)"
					:fit="fit" />
        <el-button @click="dialogInsertVisible = false">{{ $t("Sure") }}</el-button>
      </el-form>
      <!--
      <div class="add-template">
        <el-form ref="form" :model="insertform">
          <el-form-item :label="$t('memberName')">
            <el-input v-model="insertform.username" type="text"></el-input>
          </el-form-item>
          <el-form-item :label="$t('phoneNumber')">
            <el-input v-model="insertform.whatsapp" type="text"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogInsertVisible = false">{{ $t("Cancel") }}</el-button>
        <el-button type="primary" @click="insertData()">{{
          $t("Sure")
        }}</el-button>
      </span>-->
    </el-dialog>

    <!-- add renwu-->
    <el-dialog :title="$t('addRenwu') + nowfileid" :visible.sync="dialogVisible_rw" width="556px"
      :before-close="handleClose_rw">
      <div class="add-template">
        <el-form ref="form" :model="form">
          <el-form-item :label="$t('listName')">
            <el-input v-model="form.title" type="textarea" :rows="2"></el-input>
          </el-form-item>

          <el-form-item :label="$t('ziyuanList')">
            <el-radio :label="nowfiletitle"> </el-radio>
          </el-form-item>

          <el-form-item :label="$t('addRenwutime')">
            <el-date-picker v-model="form.plantime" type="datetime" :placeholder="$t('selectDatetime')">
            </el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('selectModules')" prop="excel">

            <el-select v-model="form.templateid" :placeholder="$t('pleaseSelect')">
              <el-option v-for="item in templistData" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_rw = false">{{ $t("Cancel") }}</el-button>
        <el-button type="primary" @click="sure">{{
          $t("Sure")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- add renwu资源转换对话框-->
    <el-dialog :title="$t('addzytitle')" :visible.sync="dialogVisible_zy" width="556px" :before-close="handleClose_zy">
      <div class="add-template">
        <el-form ref="form" :model="form">
          <el-form-item :label="$t('listName')">
            <el-input v-model="form.title" type="textarea" :rows="1"></el-input>
          </el-form-item>

          <el-form-item :label="$t('zybegingtime')">
            <el-date-picker v-model="form.zybegintime" type="datetime" :placeholder="$t('selectDatetime')">
            </el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('zyendtime')">
            <el-date-picker @change="sure_zy_count" v-model="form.zyendtime" type="datetime" :placeholder="$t('selectDatetime')">
            </el-date-picker>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_zy = false">{{ $t("Cancel") }}</el-button>
        <el-button v-if="!caninsert" type="primary" disabled @click="sure_zy">{{
          $t("Sure")
        }}</el-button>
        <el-button v-if="caninsert" type="primary" @click="sure_zy">{{
          $t("Sure")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- add -->
    <el-dialog :title="$t('MobileList')" :visible.sync="dialogVisible_list"
      :width="$store.state.isMobile ? '90%' : '556px'" :before-close="handleClose">
      <div class="add-template">
        <el-table :data="daifalistData.slice((currentPage - 1) * pageSize, currentPage * pageSize)
          " stripe style="width: 100%">
          <el-table-column prop="nickname" :label="$t('nickName')">
          </el-table-column>

          <el-table-column prop="whatsapp" :label="$t('whatsapp')">
          </el-table-column>

        </el-table>

        <div class="pagination flex-center">
          <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
            :page-size="pageSize" layout="total,prev,pager,next" :total="daifalistData.length"></el-pagination>
        </div>

      </div>
    </el-dialog>

  </div>
</template>
<script>

import { formatDate } from '../../assets/date.js'
import axios from 'axios'
import request from "@/utils/request";
import { tongyong, addRenwu, addDaifa, addRenwu_zy, getDaifalistByGroup, getDaifafile } from "@/api";

export default {
  data() {
    return {
      membership_read: '0',
      membership_edit: '0',
      exportcsv: '0',
      caninsert: false,
      show: false,
      plantime: '',
      templateid: '',
      title: '',
      type: 'whatsapp',
      fileList: [],
      templistData: [],
      daifalistData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      totalRecord: 0,
      daifalistByGroupCurrentPage: 1, // 当前页码
      daifalistByGroupPageSize: 10, // 每页显示的行数
      activeName: "0",
      dialogVisible: false,
      dialogVisible_rw: false,
      dialogVisible_zy: false,
      dialogVisible_list: false,
      dialogGroupVisible: false,
      dialogGroupVisibleTitle: '',
      dialogInsertVisible: false,
      tableData: [

      ],
      daifalistByGroup: [],
      nowfileid: -1,
      nowfiletitle: '',
      form: {
        type: 'whatsapp',
        title: "",
        qyid: "",
        daifaid: "",
        templateid: '',
        plantime: '',
        zybegintime: '',

        zyendtime: '',
        status: 0,
      },
      insertform: {
        insertid: "",
        username: "",
        whatsapp: "",
      },
      options: [{
        value: '选项1',
        label: '黄金糕'
      }],
      value: ''
    };
  },
  filters: {
    formatDate: function (time) {
      time = time * 1000     //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  },
  created() {
    var user = JSON.parse(window.localStorage.getItem("userinfo"));
    var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
    //this.qyid = user.id
    this.qyid = auser.qyid
    this.membership_read = auser.membership_read
    this.membership_edit = auser.membership_edit
    this.exportcsv = auser.exportcsv
    this.getlist();
  },

  methods: {
    // 页面切换方法
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getlist();
      //console.log("this.currentPage:     " + val)
    },
    handleGroupCurrentChange(val) {
      this.daifalistByGroupCurrentPage = val;
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisible_rw = false;
      this.dialogVisible_list = false;
      this.dialogGroupVisible = false;
      this.dialogInsertVisible = false;
    },
    handleClose_rw() {
      this.dialogVisible_rw = false;
      this.dialogVisible_zy = false;
      this.dialogVisible_list = false;
      this.dialogGroupVisible = false;
      this.dialogInsertVisible = false;
    },
    handleClose_zy() {
      this.dialogVisible_rw = false;
      this.dialogVisible_zy = false;
      this.dialogVisible_list = false;
      this.dialogGroupVisible = false;
      this.dialogInsertVisible = false;
    },
    handlePreview() { },
    handleRemove() { },
    beforeRemove() { },
    handleExceed() { },
    // 新增範本点击确定
    sure() {
      var user = JSON.parse(window.localStorage.getItem("userinfo"));
      console.log(user)

      if (!this.form.title) {
        this.$message.error(this.$t('pleaseSelect')+ " title");
        return
      }
      if (this.form.plantime == 0) {
        this.$message.error(this.$t('pleaseSelect')+" "+ this.$t('time'));
        return
      }

      //this.form.qyid = user.id
      this.form.qyid = this.qyid
      this.form.daifaid = this.nowfileid


      this.form.status = 0


      addRenwu(this.form).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.dialogVisible_rw = false;
          //this.getlist();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 新增範本点击确定
    sure_zy() {
      var user = JSON.parse(window.localStorage.getItem("userinfo"));

      if (!this.form.title) {
        this.$message.error(this.$t('pleaseSelect')+ " title");
        return
      }
      if (this.form.zybegintime == 0) {
        this.$message.error(this.$t('pleaseSelect')+" "+ this.$t('time'));
        return
      }

      //this.form.qyid = user.id
      this.form.qyid = this.qyid


      this.form.status = 0
      this.form.action = 'insert'


      addRenwu_zy(this.form).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.dialogVisible_zy = false;
          this.getlist();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 新增範本 tongji 
    sure_zy_count() {
      var user = JSON.parse(window.localStorage.getItem("userinfo"));


      if (this.form.zybegintime == 0) {
        this.$message.error(this.$t('pleaseSelect')+" "+ this.$t('time'));
        return
      }

      //this.form.qyid = user.id
      this.form.qyid = this.qyid


      this.form.status = 0
      this.form.action = 'count'


      addRenwu_zy(this.form).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: $t('found') + " " + res.count + " " + $t('data'),
          });
          if (res.count > 0) { this.caninsert = true }
          //  this.dialogVisible_zy = false;
          //this.getlist();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    exporttocsv(name) {
        var csvRows = [];
        // Add header row
        const header = "name,mobile";
        csvRows.push(header);

        // Add data rows
        for (let i = 0; i < this.daifalistByGroup.length; i++) {
            const row = this.daifalistByGroup[i]['nickname'] + "," + this.daifalistByGroup[i]['whatsapp'];
            csvRows.push(row);
        }

        var csvContent= csvRows.join("\n")
            .replace(/(^\[)|(\]$)/gm, "");

        var link = document.createElement('a');
        // "\ufeff"是为了解决CSV中文乱码问题
        var blob = new Blob(["\ufeff" +csvContent],{type: 'text/csv;charset=utf-8;'});
        var url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute('download', name + '.csv');
        link.click();
        document.body.removeChild(link);


    },
    // 我的模板列表
    getlist() {
      this.show = true
      console.log("go list");
      var user = JSON.parse(window.localStorage.getItem("userinfo"));
      var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
      /*
            let fdata = {
              sjk: "messenger_daifafile",
              action: "list",
      
              qyid: user.id,
              };
            tongyong(fdata).then((res) => {
              if (res.code == 1) {
                console.log(res);
                this.tableData = res.data;
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
          this.show=false
            });*/


      let fdata = {
        //qyid: user.id,
        qyid: auser.qyid,
        storeid: auser.storeid,
        record_page: this.currentPage,
        record_limit: 10,
      };
      getDaifafile(fdata).then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.tableData = res.data;
          this.totalRecord = res.total;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
        this.show = false
      });




    },


    getlist_temp() {
      console.log("go messenger_templatelist");
      var user = JSON.parse(window.localStorage.getItem("userinfo"));

      let fdata = {
        sjk: "messenger_templatelist",
        action: "list",
        status: 1,
        moresearch: 'status,',
        //qyid: user.id,
        qyid: this.qyid,
      };
      tongyong(fdata).then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.templistData = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },


    getlist_daifaid(daifaid) {
      this.dialogVisible_list = true
      console.log("go messenger_templatelist");
      var user = JSON.parse(window.localStorage.getItem("userinfo"));
      //&moresearch=daifaid,&daifaid=6
      let fdata = {
        sjk: "messenger_daifalist",
        action: "list",
        moresearch: "daifaid",
        daifaid: daifaid,

        //qyid: user.id,
        qyid: this.qyid,
      };
      tongyong(fdata).then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.daifalistData = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },


    httpRequest(option) {
      this.fileList.push(option);
    },
    // 上传前处理
    beforeUpload(file) {
      let fileSize = file.size;
      const FIVE_M = 5 * 1024 * 1024;
      //大于5M，不允许上传
      if (fileSize > FIVE_M) {
        this.$message.error(this.$t('max5mb'));
        return false;
      }
      //判断文件类型，必须是xlsx格式
      let fileName = file.name;
      let reg = /^.+(\.csv)$/;
      if (!reg.test(fileName)) {
        this.$message.error(this.$t('xlsxOnly'));
        return false;
      }
      return true;
    },
    // 文件数量过多时提醒
    handleExceed() {
      this.$message({ type: "error", message: this.$t('1attachment') });
    },

    //导入Excel病种信息数据
    submitImportForm() {
      var user = JSON.parse(window.localStorage.getItem("userinfo"));
      console.log(user);

      if (!this.title) {
        this.$message.error(this.$t('pleaseSelect')+" title");
        return
      }
      if (this.fileList.length == 0) {
        this.$message.error(this.$t('pleaseSelect')+" "+ this.$t('file'));
        return
      }

      let paramsData = new FormData();
      // 将上传文件数组依次新增到参数paramsData中
      console.log("filelist", this.fileList);

      this.fileList.forEach((x) => {
        console.log(x.file);
        paramsData.append("file", x.file);
      });
      // 将输入表单数据新增到params表单中
      paramsData.append("kgCode", "sss");
      //paramsData.append("qyid", user.id);
      paramsData.append("qyid", this.qyid);
      paramsData.append("title", this.title);
      paramsData.append("type", this.type);


      //这里根据自己封装的axios来进行调用后端接口
      console.log("paramsData", paramsData.get("file"));

      axios.post("https://w9.nowaittech.com/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_daifa_csv", paramsData).then(res => {
        console.log(res.data);

        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.getlist()
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
        this.dialogVisible = false//关闭对话框

      })
      // this.$refs.importFormRef.resetFields()//清除表单信息
      this.$refs.upload.clearFiles()//清空上传列表
      this.fileList = []//集合清空
      this.title = ''



    },

    senditem(data) {
      this.getlist_temp()
      this.nowfileid = data.id
      console.log(this.nowfileid);
      this.nowfiletitle = data.title
      console.log(this.nowfiletitle);
      this.dialogVisible_rw = true
    },
    deleteMemeber(id) {
      console.log('deleteMemeber:' + id);
      this.$confirm(this.$t('deleteConfirm'), {
        confirmButtonText: this.$t('Sure'),
        cancelButtonText: this.$t('Cancel')
      }).then(_ => {

        let fdata = {
          action: 'del',
          id: id
        }
        getDaifalistByGroup(fdata).then(res => {
          if (res.code == 1) {
            console.log(res);
            this.getlist();
            this.dialogGroupVisible = false;
          } else {
            console.log(res)
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(_ => {



      })
    },
    insertitem(id) {
      this.dialogInsertVisible = true;
      this.insertform.insertid = id;
      console.log('insertitem:' + id);
    },
    insertData() {

      console.log('insertdata:' + this.insertform.insertid);

      let fdata = {
        action: 'insert',
        qyid: this.qyid,
        insertid: this.insertform.insertid,
        username: this.insertform.username,
        whatsapp: this.insertform.whatsapp,
      }
      getDaifalistByGroup(fdata).then(res => {
        if (res.code == 1) {
          console.log(res);
          this.getlist();
          this.dialogInsertVisible = false;
        } else {
          console.log(res)
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })

    },
    edititem(id, title) {
      this.dialogGroupVisible = true;
      this.dialogGroupVisibleTitle = title;
      console.log('edit:' + id);
      let fdata = {
        daifaid: id
      }
      getDaifalistByGroup(fdata).then(res => {
        if (res.code == 1) {
          console.log(res.data);
          this.daifalistByGroup = res.data;
          //this.getlist()
        } else {
          console.log("error")
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })


    },
    //删除某个
    delitem(id) {
      this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {

        console.log('del..');
        let fdata = {
          sjk: 'messenger_daifafile',
          action: 'del',
          id: id
        }
        tongyong(fdata).then(res => {
          if (res.code == 1) {
            console.log(res);
            this.getlist()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(_ => {



      })


    },
    sortChange({ prop, order }) {
      this.tableData.sort(this.compare(prop, order));
    },
    compare(propertyName, sort) {
      return function (obj1, obj2) {
        var value1 = obj1[propertyName]
        var value2 = obj2[propertyName]
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          const res = value1.localeCompare(value2, 'zh')
          return sort === 'ascending' ? res : -res
        } else {
          if (value1 <= value2) {
            return sort === 'ascending' ? -1 : 1
          } else if (value1 > value2) {
            return sort === 'ascending' ? 1 : -1
          }
        }
      }
    },
    sortChange({ prop, order }) {
      this.tableData.sort(this.compare(prop, order));
    },
    compare(propertyName, sort) {
      return function (obj1, obj2) {
        var value1 = obj1[propertyName]
        var value2 = obj2[propertyName]
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          const res = value1.localeCompare(value2, 'zh')
          return sort === 'ascending' ? res : -res
        } else {
          if (value1 <= value2) {
            return sort === 'ascending' ? -1 : 1
          } else if (value1 > value2) {
            return sort === 'ascending' ? 1 : -1
          }
        }
      }
    },
    sortChange_group({ prop, order }) {
      this.daifalistByGroup.sort(this.compare(prop, order));
    },
  },

};
</script>
<style lang="scss" scoped>
.el-pagination__total {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  box-sizing: border-box;
}

.pendingList-wrapper {}

.pagination {
  width: 100%;
  margin: 30px auto;
}

::v-deep .el-select {
  width: 100%;
}
</style>